import PropTypes from 'prop-types'
import { Drawer, DrawerContent } from '@components/ui/drawer'
import { cn } from 'lib/utils'

export const AdasDrawer = ({ open, onClose, children, anchor = 'right', className, variant, sx, inputStyles, ...props }) => {
  const isPermanent = variant === 'permanent'

  if (isPermanent) {
    return (
      <div style={inputStyles} className={cn('flex flex-col h-full', className)} {...props}>
        {children}
      </div>
    )
  }

  const directionMap = {
    right: 'right',
    left: 'left',
    top: 'top',
    bottom: 'bottom'
  }
  const direction = directionMap[anchor] || 'right'

  return (
    <Drawer open={open} onClose={onClose} direction={direction}>
      <DrawerContent
        direction={anchor === 'right' ? 'right' : anchor === 'top' ? 'top' : anchor === 'bottom' ? 'bottom' : 'left'}
        style={inputStyles}
        className={cn('w-[340px] sm:w-[420px]', className)}
        {...props}
      >
        {children}
      </DrawerContent>
    </Drawer>
  )
}

AdasDrawer.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  anchor: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  className: PropTypes.string,
  variant: PropTypes.string,
  sx: PropTypes.object,
  inputStyles: PropTypes.object
}
